// Video or voice only, at any time during the call (Wes, Sept 28 2026). A tray
// button in the approved call look: it switches between the 3D Otto and the 2D
// Otto card, and tells the server (`mode` event).
import { AudioLines, Video } from "lucide-react";
import type { ConsultStrings } from "../strings";

export type CallMode = "video" | "voice";

export function ModeToggle({
  s,
  mode,
  onChange,
  fellBack = false,
}: {
  s: ConsultStrings;
  mode: CallMode;
  onChange: (mode: CallMode) => void;
  /** The 3D Otto fell back to his picture: in video, the button tries the 3D Otto again instead of leaving video. */
  fellBack?: boolean;
}) {
  const retry = mode === "video" && fellBack;
  const next: CallMode = retry ? "video" : mode === "video" ? "voice" : "video";
  const label = retry ? s.call.retry3d : next === "voice" ? s.call.switchToVoice : s.call.switchToVideo;
  return (
    <button
      type="button"
      className="consult-call-tray-button consult-mode-toggle"
      onClick={() => onChange(next)}
      aria-label={label}
      title={label}
      data-mode={mode}
    >
      <span className="consult-call-tray-button__icon" aria-hidden="true">
        {mode === "video" ? <Video size={20} strokeWidth={2.2} /> : <AudioLines size={20} strokeWidth={2.2} />}
      </span>
      <span className="consult-call-tray-button__label" aria-hidden="true">
        {mode === "video" ? s.call.video : s.call.voice}
      </span>
    </button>
  );
}
